import ShopifyHits from '@/mixins/hitItem'
import MzShopifySearchBox from './custom/MzShopifySearchBox'
import MzShopifyRecommendations from './custom/MzShopifyRecommendations'
import MzReviews from './custom/MzReviews'
import MzStar1 from './custom/MzStar1'
import MzStar2 from './custom/MzStar2'
import MzStar3 from './custom/MzStar3'

function install(Vue) {
  Vue.component('MzShopifySearchBox', MzShopifySearchBox)
  Vue.component('MzShopifyRecommendations', MzShopifyRecommendations)
  Vue.component('MzReviews', MzReviews)
  Vue.component('MzStar1', MzStar1)
  Vue.component('MzStar2', MzStar2)
  Vue.component('MzStar3', MzStar3)
}

// Create module definition for Vue.use()
const plugin = {
  install
}

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue
}
if (GlobalVue) {
  GlobalVue.use(plugin)
}

export default plugin

export {
  ShopifyHits,
  MzShopifySearchBox,
  MzShopifyRecommendations,
  MzReviews,
  MzStar1,
  MzStar2,
  MzStar3
}
